import { Gql } from '@fiverr-private/dynamic_matching';
import { DynamicSection, SectionTypes } from '@fiverr-private/ai_brief';
import { DAY_IN_MS } from '@fiverr-private/futile';
import { appTranslate } from '../../../i18n';
import { BriefClassificationResponse } from '../../../api';
import { ViewTimeline } from './ViewTimeline';
import { EditTimeline } from './EditTimeline';
import { TitleTimeline } from './TitleTimeline';

export const getTimelineSection = (briefClassification: BriefClassificationResponse): DynamicSection => {
    const extractedTimeline =
        briefClassification.resolved_data?.delivery_time?.timeline?.toLowerCase() ===
        Gql.DmBriefTimeline.SpecificDate.toLowerCase()
            ? Gql.DmBriefTimeline.SpecificDate
            : null;

    const extractedDeliveryDate = briefClassification.resolved_data?.delivery_time?.delivery_date;
    const deliveryDateTimestamp = new Date(`${extractedDeliveryDate}T00:00:00Z`).getTime();
    const tomorrowTimestamp = new Date(new Date().getTime() + DAY_IN_MS).setHours(0);
    const isAllowedDate = !isNaN(deliveryDateTimestamp) && deliveryDateTimestamp >= tomorrowTimestamp;
    return {
        id: 'timeline',
        mandatory: true,
        title: appTranslate('sections.timeline.title').toString(),
        content:
            extractedTimeline && isAllowedDate // for now supports only Specific Date extraction
                ? {
                      timeline: extractedTimeline,
                      deliveryDate: deliveryDateTimestamp,
                  }
                : {},
        included: true,
        type: SectionTypes.dynamic,
        ViewComponent: ViewTimeline,
        EditComponent: EditTimeline,
        TitleComponent: TitleTimeline,
        hideActions: true,
    };
};

export interface TimelineContentType {
    timeline?: Gql.DmBriefTimeline;
    deliveryDate?: number;
}

export * from './ViewTimeline';
export * from './EditTimeline';
export * from './TitleTimeline';
